import useTypedContext from "hooks/useTypedContext";
import { StackContext } from "views/Stack/Context";
import useCanLockStack from "shared/Stack/access/useCanLockStack";
import useCanUnlockStack from "shared/Stack/access/useCanUnlockStack";

import LockButton from "../LockButton";
import UnlockButton from "../UnlockButton";

const StackLockOrUnlockButton = () => {
  const { stack } = useTypedContext(StackContext);

  const canLockStack = useCanLockStack()(stack);
  const canUnlockStack = useCanUnlockStack()(stack);

  return (
    <>
      {(canLockStack.result || canLockStack.message) && (
        <LockButton stackId={stack.id} disabledTooltip={canLockStack.message} />
      )}
      {(canUnlockStack.result || canUnlockStack.message) && (
        <UnlockButton stackId={stack.id} disabledTooltip={canUnlockStack.message} />
      )}
    </>
  );
};

export default StackLockOrUnlockButton;
